import React from "react";
import { IHotelReviewsDetailedSummary } from "services/BookingManagerApi/types/HotelReviews";
import { SvgIcon } from "ui/SvgIcon";
import { ArrowPlayIcon } from "ui/Icons";

export const Feedback = ({ strengths, areasForImprovement, title, strengthTitle }: IHotelReviewsDetailedSummary & { title: string, strengthTitle: string }) => {
  return (
    <div className="feedback-container font-pt-sans w-full mx-10px">
      <h3 className="text-17px font-bold text-black m-0 mb-20px">{title}</h3>
      {strengths.length > 0 && (
        <div className="feedback-strengths">
          <div className="feedback-title flex items-center gap-8px bg-brown-10 rounded h-[32px] px-8px">
            <SvgIcon IconComponent={ArrowPlayIcon} className="fill-green-message w-[12px] h-[12px] flex items-start" />
            <h4 className="text-17px font-bold text-black m-0">{strengthTitle}</h4>
          </div>
          <ul className="feedback-list mt-5px pl-29px">
            {strengths.map((strength) => <li key={strength} className="text-15px leading-24px font-normal">{strength}</li>)}
          </ul>
        </div>
      )}
      {areasForImprovement.length > 0 && (
        <div className="feedback-areas-for-improvement">
          <div className="feedback-title flex items-center gap-8px bg-brown-10 rounded h-[32px] px-8px">
            <SvgIcon IconComponent={ArrowPlayIcon} className="fill-red-95 w-[12px] h-[12px] flex items-start rotate-180" />
            <h4 className="text-17px font-bold text-black m-0">Areas for improvement</h4>
          </div>
          <ul className="feedback-list mt-5px pl-29px">
            {areasForImprovement.map((area) => <li key={area} className="text-15px leading-24px font-normal">{area}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
};